import { IEnvironment } from "./environment";

export const orionEnv: IEnvironment = {
  env: "orion",
  api: {
    protocol: "https",
    host: "api-aurora.oriontelekom.rs",
    port: "",
  },
  oidc: {
    clientId: "323340801218248707@auroradms",
    issuerEndpoint: "https://auth-aurora.oriontelekom.rs",
    loginCallbackUrl: "https://aurora.oriontelekom.rs/code",
    authorizationEndpoint: "https://auth-aurora.oriontelekom.rs/oauth/v2/authorize",
    scope: "openid profile email urn:zitadel:iam:user:metadata",
    keyListEndpoint: "https://auth-aurora.oriontelekom.rs/oauth/v2/keys",
    userInfoEndpoint: "https://auth-aurora.oriontelekom.rs/oidc/v1/userinfo",
    roleFieldName: "urn:zitadel:iam:org:project:323340638110089219:roles",
    endSessionEndpoint: "https://auth-aurora.oriontelekom.rs/oidc/v1/end_session",
  },
  modulesEnabled: {
    archive: false,
    digitalSignature: true,
    qualifiedDigitalSignature: true,
    tasks: false,
    sefProvider: false,
    emailListenerProvider: false,
    networkShareProvider: false,
    ocr: false,
  },
  documentTableColumns: {
    userName: false,
    description: true,
    creationDate: true,
    archiveDate: false,
    documentType: true,
    documentStatus: true,
    tags: true,
  },
};
